import { ProjectDetails } from "../../types";
import { Button, Tooltip, Typography } from "antd";
import { Settings, LayoutGrid, Loader2 } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { PlanTag } from "../PlanTag";

const { Paragraph, Text } = Typography;

interface ProjectCardProps {
    project: ProjectDetails;
}

const ProjectCard = ({ project }: ProjectCardProps) => {
    const navigate = useNavigate();
    const isLoadingEnvs = project.environments === undefined;
    const environments = project.environments || [];
    const envCount = environments.length;
    const envNames = environments.map(e => e.name).join(", ");

    return (
        <div
            className="project-card"
            onClick={() => navigate(`/projects/${project.id}/environments`)}
        >
            {/* Header: Name and Settings */}
            <div className="project-card-header">
                <Text strong className="project-card-name">
                    {project.name}
                </Text>
                <Link
                    to={`/projects/${project.id}/settings`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Button
                        type="text"
                        icon={<Settings size={16} />}
                        className="project-card-settings-btn"
                    />
                </Link>
            </div>

            {/* Description */}
            <Paragraph
                ellipsis={{ rows: 2, tooltip: project.description }}
                className="project-card-description"
            >
                {project.description || <span className="project-card-no-desc">No description</span>}
            </Paragraph>

            {/* Environments count */}
            <div className="project-card-envs">
                {isLoadingEnvs ? (
                    <>
                        <Loader2 size={16} className="project-card-envs-icon animate-spin" />
                        <span className="project-card-loading-envs">Loading environments...</span>
                    </>
                ) : (
                    <>
                        <LayoutGrid size={16} className="project-card-envs-icon" />
                        {envCount > 0 ? (
                            <Tooltip title={envNames}>
                                <span>
                                    {envCount} environment{envCount !== 1 ? 's' : ''}
                                </span>
                            </Tooltip>
                        ) : (
                            <span className="project-card-no-envs">No environments</span>
                        )}
                    </>
                )}
            </div>

            {/* Spacer to push footer to bottom */}
            <div className="project-card-spacer" />

            {/* Footer: Plan tag */}
            {project.paymentPlan && (
                <div className="project-card-footer">
                    <PlanTag planId={project.paymentPlan.id} planName={project.paymentPlan.name} />
                </div>
            )}
        </div>
    );
};

export default ProjectCard;
